import {
    USER_ROLES_INIT,
    USER_ROLES_REQUEST,
    USER_ROLES_SUCCESS,
    USER_ROLES_ASSIGN,
    USER_ROLES_REQUEST_FAIL,
    USER_ROLES_POPUP_REQUEST,
    USER_ROLES_POPUP_REQUEST_FAIL,
    USER_ROLES_PASS_POPUP_REQUEST,
} from "../action-types/userRole"

const userRoleInit = {
    loading: false,
    message: "",
    successStatus: false,
    userRolesArray: [],
    popupLoading: false,
    popupSuccessStatus: false,
    popupMessage: "",
}
export default function userRoleReducer(state = userRoleInit, action) {
    switch (action.type) {
        case USER_ROLES_INIT: {
            return userRoleInit
        }
        case USER_ROLES_REQUEST: {
            return { ...state, loading: true }
        }
        case USER_ROLES_SUCCESS: {
            const { userId, userRoles } = action.payload
            let NewUserRolesArray = [...state.userRolesArray]
            if (!NewUserRolesArray.length) {
                NewUserRolesArray.push({ userId, userRoles })
            } else {
                NewUserRolesArray = NewUserRolesArray.map((item) => {
                    if (item.userId === userId) {
                        return { ...item, userId, userRoles }
                    }
                    return item
                })
            }
            return {
                ...state,
                loading: false,
                successStatus: true,
                userRolesArray: NewUserRolesArray,
            }
        }
        case USER_ROLES_ASSIGN: {
            const { userId, userRoles } = action.payload
            const NewUserRolesArray = [...state.userRolesArray]
            const foundIndex = NewUserRolesArray.findIndex((item) => item.userId === userId)
            if (foundIndex === -1) {
                // new record
                NewUserRolesArray.push({ userId, userRoles })
            } else {
                // update existing record
                NewUserRolesArray[foundIndex].userRoles.push(userRoles)
            }
            return {
                ...state,
                popupLoading: false,
                popupSuccessStatus: true,
                userRolesArray: NewUserRolesArray,
            }
        }
        case USER_ROLES_PASS_POPUP_REQUEST: {
            return {
                ...state,
                popupLoading: false,
                popupSuccessStatus: true,
            }
        }
        case USER_ROLES_REQUEST_FAIL: {
            return {
                ...state,
                loading: false,
                successStatus: false,
                message: action.payload,
            }
        }
        case USER_ROLES_POPUP_REQUEST: {
            return { ...state, loading: false, popupLoading: true, popupSuccessStatus: false, popupMessage: "" }
        }
        case USER_ROLES_POPUP_REQUEST_FAIL: {
            return { ...state, loading: false, popupLoading: false, popupSuccessStatus: false, popupMessage: action.payload }
        }
        default:
            return state
    }
}
